import { Tabs, TabsList, TabsTrigger } from "app/shadcnComponents/ui/tabs";

interface PillTabSelectorProps {
  availableTabs: {
    label: string;
    count?: number;
    value?: string;
  }[];
  selectedTab: string;
  onTabChange: (tab: string) => void;
}

const PillTabSelector = ({
  availableTabs,
  selectedTab,
  onTabChange,
}: Readonly<PillTabSelectorProps>) => {
  return (
    <Tabs value={selectedTab} onValueChange={onTabChange}>
      <TabsList className="inline-flex gap-2 bg-transparent p-0 h-auto flex-wrap">
        {availableTabs.map((tab) => (
          <TabsTrigger
            key={tab.label}
            value={tab.value ?? tab.label}
            className="group rounded-full border-[1px] border-subtle px-3 py-2 text-sm font-normal text-gray-700 shadow-none data-[state=active]:bg-interactive-fill data-[state=active]:border-sapphire-20 data-[state=active]:text-interactive"
          >
            {tab.label}
            {tab.count !== undefined && (
              <div className="d-flex align-items-center justify-content-center w-[16px] h-[16px] rounded-full bg-slate-10 ms-1 group-data-[state=active]:bg-sapphire-20">
                <span className="text-gray-500 group-data-[state=active]:text-interactive text-[length:var(--fontSize-micro)]">
                  {tab.count}
                </span>
              </div>
            )}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
};

export default PillTabSelector;
